import { z } from 'zod';

import { logError } from '~/common/utils/log';

const gatesSchema = z
  .object({
    w9Required: z.boolean(),
    docvRequired: z.boolean(),
  })
  .strict();

const withdrawalEligibilitySchema = z.object({
  eligible: z.boolean(),
  gates: gatesSchema,
  evaluatedAmountCents: z.number().optional(),
});

const withdrawalEligibilityEnvelopeSchema = z.object({
  id: z.string().optional(),
  data: withdrawalEligibilitySchema,
});

export type IGetWithdrawalEligibility = z.infer<typeof withdrawalEligibilitySchema>;

export type ContractReport = (message: string, context: Record<string, unknown>) => void;

export const parseWithdrawalEligibility = (
  raw: unknown,
  report: ContractReport = logError
): IGetWithdrawalEligibility | undefined => {
  const result = withdrawalEligibilityEnvelopeSchema.safeParse(raw);

  if (result.success === false) {
    report('Unexpected withdrawal-eligibility response shape', {
      issues: result.error.issues.map((issue) => issue.path.join('.')),
    });
    return undefined;
  }

  return result.data.data;
};
